import { alertError } from "../../utils/feedback";
import {
  REQUEST_STARTED,
  REQUEST_SUCCEEDED,
  REQUEST_FAILED,
  LOGED_OUT,
} from "../types/feedbackTypes";
import { automaticSignOut } from "./userActionCreators";

export const requestStarted = (boul) => ({
  type: REQUEST_STARTED,
  payload: boul,
});

export const requestSucceeded = () => ({
  type: REQUEST_SUCCEEDED,
});

export const loggedOut = () => ({
  type: LOGED_OUT,
});

export const requestFailed = (err) => {
  const local = localStorage.getItem("i18nextLng").slice(0, 2) || "en";

  const storedUser = localStorage.getItem("user");

  let errorMessage;

  if (local === "en") {
    errorMessage =
      err?.message || (err?.message === null ? undefined : "Request failed");
  } else if (local === "fr") {
    errorMessage =
      err?.message_fr ||
      (err?.message_fr === null ? undefined : "Request failed");
  }

  if (
    err &&
    err.response &&
    err.response.data &&
    err.response.data.error &&
    typeof err.response.data.error === "string"
  ) {
    errorMessage = err.response.data.error;
  }
  if (
    err &&
    err.response &&
    err.response.data &&
    err.response.data.error &&
    err.response.data.error.details
  ) {
    errorMessage =
      err.response.data.error.details[0] && local === "en"
        ? err.response.data.error.details[0].message
        : err.response.data.error.details[0].message_fr;
  }
  if (err && err.error_ === "token expired") {
    return automaticSignOut();
  }
  if (errorMessage && err !== "automaticLogout") {
    alertError(errorMessage);
  }

  return {
    type: REQUEST_FAILED,
    payload: errorMessage,
  };
};
